import { apiFetch } from "./client";
import type {
  AccountListResponse,
  AccountOverviewResponse,
  AccountActivitySummaryResponse,
} from "./types";

export interface AccountListQuery {
  offset?: number;
  limit?: number;
  search?: string;
  scope?: "assigned" | "all";
  segment?: string;
}

export function fetchAccountList(
  q: AccountListQuery = {},
  signal?: AbortSignal,
): Promise<AccountListResponse> {
  return apiFetch<AccountListResponse>("/Custom/frontend/accounts", {
    query: {
      offset: q.offset,
      limit: q.limit,
      search: q.search || undefined,
      scope: q.scope,
      segment: q.segment || undefined,
    },
    signal,
  });
}

export function fetchAccountOverview(
  id: string,
  signal?: AbortSignal,
): Promise<AccountOverviewResponse> {
  return apiFetch<AccountOverviewResponse>(
    `/Custom/frontend/account/${encodeURIComponent(id)}/overview`,
    { signal },
  );
}

export function fetchAccountActivitySummary(
  id: string,
  q: { offset?: number; limit?: number; filter?: string } = {},
  signal?: AbortSignal,
): Promise<AccountActivitySummaryResponse> {
  return apiFetch<AccountActivitySummaryResponse>(
    `/Custom/frontend/account/${encodeURIComponent(id)}/activity-summary`,
    {
      query: { offset: q.offset, limit: q.limit, filter: q.filter || undefined },
      signal,
    },
  );
}
